// extracted by mini-css-extract-plugin
export default {"closedMessageBody":"_1gp8HhvXmKdpRkYIKtO4Ov"};